module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/groups/groups-list/groups-list.component.css
// module id = ./src/app/groups/groups-list/groups-list.component.css
// module chunks = main